(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-pagination-link]');
    if (!link) return;
    // Respect new-tab / modified clicks / middle-click — let the browser handle them.
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    // Purely cosmetic: fade the grid; navigation is NOT delayed.
    document.documentElement.classList.add('pagination-fade-out');
  });

  // Clean up if the user comes back via bfcache.
  window.addEventListener('pageshow', function () {
    document.documentElement.classList.remove('pagination-fade-out');
  });
})();